import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { CustomPatientGroupsRemoveModalLoader } from './CustomPatientGroupsRemoveModal.loader';
import { CustomPatientGroupsRemoveModalContent } from './CustomPatientGroupsRemoveModalContent';
import { CustomPatientGroupsRemoveAction } from './CustomPatientGroupsRemoveModal.actions';

type CustomPatientGroupsRemoveModalProps = {
   patientGroupId: number;
   patientGroupName: string;
   onClose: VoidFunction;
};

export const CustomPatientGroupsRemoveModal = (props: CustomPatientGroupsRemoveModalProps): JSX.Element => {
   return (
      <Modal title={translationKeys.removeCustomGroup} width={ModalWidth.NORMAL} testId={'customPatientGroupsRemove'}>
         <CustomPatientGroupsRemoveModalLoader patientGroupId={props.patientGroupId}>
            {({ numberAssignedPatients }) => (
               <CustomPatientGroupsRemoveModalContent
                  patientGroupName={props.patientGroupName}
                  numberAssignedPatients={numberAssignedPatients}
               />
            )}
         </CustomPatientGroupsRemoveModalLoader>
         <CustomPatientGroupsRemoveAction patientGroupId={props.patientGroupId}>
            {({ removeCustomPatientGroup }) => (
               <ModalConfirmButton label={translationKeys.remove} onClick={removeCustomPatientGroup} />
            )}
         </CustomPatientGroupsRemoveAction>
         <ModalCancelButton onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
